import { Link } from "react-router-dom";
import React from "../../assets/icons/react-icon.png";
import pdf from "../../assets/pdf/Resume.pdf";
import picture from "../../assets/image/portrait.jpg"
const About = () => {

  return (
    <section className="about">
      <div className="about__img-wrap">
          <div className="about__img-container">
        <img className="about__img-portrait" src={picture} alt="profile"></img>
      </div>
      <h1 className="about__title">ABOUT ME</h1>
      </div>
      <div className="about__wrapper">
        <div className="about-container">
        </div>
        <div>
          <p className="about__text">
            Hey, I’m Kimberly 👋

            Born and raised in Miri, Malaysia, I’ve always been fascinated by the art of turning problems into solutions.
            <br />
            <br />
            For me, programming isn’t just a career—it’s a creative outlet, a challenge, and occasionally, a little bit of magic.

            I’ve always enjoyed figuring out how things work and finding ways to make them work better. Programming gave me the perfect playground for that curiosity. Whether I’m building a web application, untangling a stubborn bug, or learning something completely new, I genuinely enjoy the process of turning an idea into something real.

            I’m a developer who believes that great code is more than just making things work. It’s about solving the right problems, creating meaningful experiences, and continuously finding ways to improve.

            So, you could call me a **coding wizard** 🧙‍♀️—curious, persistent, and always ready for the next challenge.

            <br />
            <br />
            If you
            are seeking an individual who embodies these qualities and possesses
            an unwavering passion for programming, then I am the ideal candidate
            for your team.
          </p>
          <Link
            className="about__resume about__resume--tablet"
            to={pdf}
            target="_blank"
          >
            RESUME
          </Link>
        </div>
      </div>
      <Link className="about__resume" to={pdf} target="_blank">
        RESUME
      </Link>
    </section>
  );
};

export default About;
